import AppPageEmpty from '@/components/app-page/index-empty.vue';

export default [{
  path: '/event-manage',
  name: 'EventManage',
  component: AppPageEmpty,
  meta: {
    title: '事件分析',
    style: 'help',
  },
  children: [
    {
      path: 'list',
      name: 'EventList',
      component: () => import('@/views/event-manage/list/index.vue'),
      meta: {
        title: '事件列表',
        style: 'tickets',
        activeMenu: '/event-manage/list',
        isUseAppInfo: true,
      },
    },
    {
      path: 'pageEventAnalysis',
      name: 'pageEventAnalysis',
      component: () => import('@/views/event-manage/page-analysis/index.vue'),
      meta: {
        title: '页面事件分析',
        style: 's-data',
        activeMenu: '/event-manage/pageEventAnalysis',
        isUseAppInfo: true,
      },
    },
    {
      path: 'eventAnalysis',
      name: 'EventAnaylysis',
      component: () => import('@/views/event-manage/analysis/index.vue'),
      meta: {
        title: '事件分析',
        style: 'sunny',
        activeMenu: '/event-manage/eventAnalysis',
        isNotMenu: true,
        isUseAppInfo: true,
      },
    },
  ],
}];
